import React from 'react'

import './Modal.css'

const Modal = ({ show, children }) => {
  return (
    show ?
      <div>
        <div className="modal-container">
          {children}
        </div>
      </div>
    : null
  )
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js